"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @LastEditTime: 2022-09-29 17:20:57
 */
// @ts-ignore: third party
var ks_bridge_1 = __importDefault(require("@ks/ks-bridge"));
var base_1 = __importDefault(require("../base"));
var index_1 = require("../util/index");
var BIZ_KEY = 'NEW_SELLER_LOCAL_LIFE';
var SETTLE_PATH = "/services/merchant/apply-v2/index.html?enableWK=1#/select-account-type?accountGroupKey=";
// const WITHDRAW_PATH = `/kspay/account/withdraw/index.html#/index?accountGroupKey=`;
var WITHDRAW_PATH = "/kspay-v2/withdraw?accountGroupKey=";
var PROMOTER = "/services/merchant/apply/index.html?enableWK=1#/select-account-type?accountGroupKey=";
var CASHOUT_WECHAT_PATH = "/services/merchant/merchant-bill/#/wechatRecord?accountGroupKey=";
var CASHOUT_ALIPAY_PATH = "/services/merchant/merchant-bill/#/alipayRecord?accountGroupKey=";
var paymentJump = {
    getHost: function () {
        if (base_1.default.isProd() || (0, index_1.isPrt)()) {
            return 'https://www.kuaishoupay.com';
        }
        else if ((0, index_1.isStaging)()) {
            return 'https://kspay-staging.test.gifshow.com';
        }
        else {
            return 'https://payservices-web.test.gifshow.com';
        }
    },
    getSettingUrlForMerchant: function (bizKey) {
        return "".concat(this.getHost()).concat(SETTLE_PATH).concat(bizKey || BIZ_KEY);
    },
    getSettingUrlBaseForPromoter: function (bizKey) {
        return "".concat(this.getHost()).concat(PROMOTER).concat(bizKey || BIZ_KEY);
    },
    // 商家入驻跳转
    jump: function (bizKey) {
        base_1.default.jumpToExternal({
            url: this.getSettingUrlForMerchant(bizKey),
        });
    },
    getSettingUrlForPromoter: function (bizKey) {
        return "".concat(this.getSettingUrlBaseForPromoter(bizKey), "&role=promoter");
    },
    // 分销者入驻的跳转
    jumpForPromoter: function (bizKey) {
        base_1.default.jumpToExternal({
            url: this.getSettingUrlForPromoter(bizKey),
        });
    },
    // 跳转提现页面
    jumpToWithdraw: function (bizKey) {
        ks_bridge_1.default.loadUrlOnNewPage({
            url: "".concat(this.getHost()).concat(WITHDRAW_PATH).concat(bizKey || BIZ_KEY)
        });
    },
    //提现聚合页 跳转微信提现
    jumpToWechat: function (params) {
        var allParams = '';
        for (var key in params) {
            allParams += "&".concat(key, "=").concat(params[key]);
        }
        ks_bridge_1.default.loadUrlOnNewPage({
            url: "".concat(this.getHost()).concat(CASHOUT_WECHAT_PATH).concat(BIZ_KEY).concat(allParams)
        });
    },
    //提现聚合页 跳转支付宝提现
    jumpToAlipay: function (params) {
        var allParams = '';
        for (var key in params) {
            allParams += "&".concat(key, "=").concat(params[key]);
        }
        ks_bridge_1.default.loadUrlOnNewPage({
            url: "".concat(this.getHost()).concat(CASHOUT_ALIPAY_PATH).concat(BIZ_KEY).concat(allParams)
        });
    }
};
exports.default = paymentJump;
